// extracted by mini-css-extract-plugin
module.exports = {"stateView":"STE2_stateView__1OSoT","onDevice":"STE2_onDevice__TDyxg","offDevice":"STE2_offDevice__3U5OL","alarm":"STE2_alarm__3a8lb"};